export default __webpack_public_path__ + "bb5a6a51ed0de8606dab1048d1cda70f.svg";